/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { RotateSquareLeftIcon16Light } from './RotateSquareLeftIcon16Light';
import { RotateSquareLeftIcon16Regular } from './RotateSquareLeftIcon16Regular';
import { RotateSquareLeftIcon16Solid } from './RotateSquareLeftIcon16Solid';
import { RotateSquareLeftIcon20Light } from './RotateSquareLeftIcon20Light';
import { RotateSquareLeftIcon20Regular } from './RotateSquareLeftIcon20Regular';
import { RotateSquareLeftIcon20Solid } from './RotateSquareLeftIcon20Solid';
import { RotateSquareLeftIcon24Regular } from './RotateSquareLeftIcon24Regular';
import { RotateSquareLeftIcon24Solid } from './RotateSquareLeftIcon24Solid';
import { RotateSquareLeftIcon32Regular } from './RotateSquareLeftIcon32Regular';
import { RotateSquareLeftIcon64Regular } from './RotateSquareLeftIcon64Regular';
var sizes = {
    16: {
        light: RotateSquareLeftIcon16Light,
        regular: RotateSquareLeftIcon16Regular,
        solid: RotateSquareLeftIcon16Solid,
    },
    20: {
        light: RotateSquareLeftIcon20Light,
        regular: RotateSquareLeftIcon20Regular,
        solid: RotateSquareLeftIcon20Solid,
    },
    24: {
        regular: RotateSquareLeftIcon24Regular,
        solid: RotateSquareLeftIcon24Solid,
    },
    32: {
        regular: RotateSquareLeftIcon32Regular,
    },
    64: {
        regular: RotateSquareLeftIcon64Regular,
    },
};
export var RotateSquareLeftIcon = forwardRef('RotateSquareLeftIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
